module.exports = __webpack_public_path__ + "img/ai-img.f3aca360.png";